<div class="flex justify-between mb-6">
  <button mat-icon-button aria-label="Back" pdNavigateBack>
    <mat-icon>arrow_back</mat-icon>
  </button>

  <pd-app-title sizeClass="text-5xl"></pd-app-title>

  <span class="spacer"></span>
</div>

<h1>Terms of Use</h1>
<p>Welcome to PersonaliDate.com.</p>
<p>
  This is a legal agreement between you and PersonaliDate.com. If you create an
  account, or use any part of this website and our services, you are expressing
  unconditional agreement to comply with and be bound by the following terms of
  use, and our privacy policy.
</p>
<p class="font-bold">
  We reserve the right to change this agreement at our sole discretion at any
  time. Any such changes will be posted on the Site. Your continued use of this
  Site or its Services after any revisions to this agreement were posted will
  constitute your acceptance of such revisions. This Agreement was last revised
  on 2/25/2013.
</p>
<ul>
  <li>
    <span class="font-bold">
      You must be 18 years old or older to use this site, or to create an
      account on this site.
    </span>
    <br />
    By creating an account, you certify that you are at least 18 years old.

    <p class="mt-2">
      For more details about our age-verification and child safety policies,
      please see our
      <a routerLink="/safety-standards">Child Safety Standards</a> page.
    </p>
  </li>
  <li>
    <span class="font-bold">
      We reserve the right to deny service to anyone for any reason. We also
      reserve the right to terminate any account for any reason.
    </span>
    We do not abuse these rights, but if we find that a user is abusing an
    account, or any feature/function of our site in anyway, we reserve the right
    to terminate his/her account without an obligation to explain/justify or
    inform him/her of our decision to do so.
  </li>
  <li>
    <span class="font-bold">
      Your use of the PersonaliDate site and services is entirely at your own
      risk, for which we shall not be liable.
    </span>
    It shall be your own responsibility to ensure that any features, services or
    information available through this website meet your specific requirements.
  </li>
  <li>
    <span class="font-bold">
      You agree to provide the information our questionnaire asks for, and to be
      honest.
    </span>
    By creating an account, you warrant that the information you provide is
    accurate.
  </li>
  <li>
    We do not do background checks on our members to confirm eligibility, age,
    relationship status, criminal history, or the accuracy of the information
    they provide. We provide our services in good faith that they are being
    honest, and we match them according to the information they provide. If any
    of our users end up being offended, scammed, harassed, upset, or otherwise
    abused by another user, or feel that they were put in touch or matched with
    someone they find unsuitable in any way, or find that someone younger than
    18 years of age is using our site, we will not be held responsible.
  </li>
  <li>
    <span class="font-bold">
      We do not make any guarantees, expressed or implied.
    </span>
    We do not guarantee that we will find you a match. We do not guarantee that
    any matches we present will be interested in you or be willing to be in
    touch with you. We do not guarantee that you will be compatible with the
    matches we present to you, now or in the future. We do not guarantee
    uninterrupted availability of our services.
  </li>
  <li>
    This site is intended to be used in the United States of America.
    <span class="font-bold">
      You agree that you will use PersonaliDate site and services in accordance
      with all International, federal, state, and local laws applicable in your
      jurisdiction.
    </span>
    It is your responsibility to determine what those laws are and to ensure
    that your use of the PersonaliDate site and services is in compliance with
    them.
  </li>
  <li>
    <span class="font-bold">
      Your account is exclusively for your personal use only.
    </span>
    You may not transfer/assign your account or your login information with/to
    any other person or entity.
  </li>
  <li>
    New features/functions/capabilities may be introduced and put in use, the
    design and layout of any or all parts of the site may be changed, or
    existing features/functions/capabilities provided may be updated, edited,
    removed without warning, as we see fit. Any of these or similar occurrences
    do not count as reason to terminate this agreement, or to claim a refund.
  </li>
  <li>
    You will not harass, threaten, annoy, intimidate any PersonaliDate users,
    employees, agents, or owners.
  </li>
  <li>
    <span class="font-bold">
      You will not solicit/advertise any services, goods, websites, etc. using
      the PersonaliDate site or services.
    </span>
    You will not spam or bulk email other users. If you violate this term, you
    agree to be held responsible, and to pay for, any-and-all related damages,
    costs, and fees to PersonaliDate.
  </li>
  <li>
    <span class="font-bold text-lg error">
      Use PersonaliDate at your own risk. You claim all
      risk/liability/responsibility for any and all damages directly or
      indirectly related to the use of our site and services - no exceptions.
    </span>
    <ul class="text-lg">
      <li>
        To the maximum extent permitted by applicable law, under no
        circumstances will PersonaliDate be liable for any incidental,
        consequential, special or indirect damages directly or indirectly caused
        by the use or incapability to use the site or services, even if
        PersonaliDate knows or has been advised of the possibility of such
        damages. To the maximum extent permitted by applicable law, in no event
        will PersonaliDate's aggregate liability, in any form of action
        whatsoever exceed the price paid by you for your account, or $30.00 USD
        if you have not paid PersonaliDate for your account.
      </li>
      <li>
        To the maximum extent permitted by applicable law, the
        risk/liability/responsibility is all yours if you experience any
        harm/loss and/or accrue any damages whatsoever, including, without
        limitation direct, indirect, general, special, compensatory,
        consequential, and/or incidental, caused by or relating to the conduct
        of you or anyone else in connection with the use of our site or
        services, whether the damage is bodily injury, emotional distress,
        and/or any other damages resulting from communications or meetings with
        other registered users of our site or services. This includes any
        claims, losses or damages caused by the conduct of users who have
        registered under false pretenses or who attempt to defraud or harm you.
      </li>
    </ul>
  </li>
  <li>
    <span class="font-bold">
      PersonaliDate owns and retains all proprietary material on this website.
    </span>
    This material includes, but is not limited to, the design, layout, look,
    appearance and graphics, the code, algorithms, features, functionality, and
    language used. Reproduction and reuse of any of this material is prohibited
    other than in accordance with the copyright notice, which forms part of
    these terms and conditions.
  </li>
  <li>
    <span class="font-bold">
      You will not use PersonaliDate to distribute or upload any virus, bot, or
      malicious software of any type,
    </span>
    or do anything that might cause harm to the PersonaliDate, our website, our
    services, its systems, or any of our members' systems in any way.
  </li>
  <li>
    <span class="font-bold">
      You will keep your conduct clean and friendly.
    </span>
    You will not use PersonaliDate, our services, and our website to engage in
    harassment, bullying, hate-speech, abuse, slander, libel, copyright
    infringement, commercial solicitation, or other offensive/unlawful behavior.
  </li>
  <li>
    If you notice any violation of these terms, or of our privacy policy, by
    anyone, you will report them to us immediately.
  </li>
</ul>
